<template>
    <div>
        terceira
    </div>
</template>

<script>

export default {
    name: "super-checkout-intern-modal-thirdTab",
    props: ["view"],
    data(){
        return {
            t: [],
        }
    },

    mounted () {
    },

    methods: {
    },

    computed: {
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// resources/office/js/components/super-checkout-intern/modal/thirdTab.vue